import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import Select from 'react-select'

import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState({
		'id': "",
	})
	const [providerTypes, setProviderTypes] = useState([])
	const [users, setUsers] = useState([])

	async function getSmsProvider() {
		var filterUrl = `/chain/telephony-provider`

		var response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data);
	}

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (data.id) {
			response = await PUT('/chain/telephony-provider', data, { loader: true })
		} else {
			response = await POST('/chain/telephony-provider', data, { loader: true })
			if (httpOk(response)) getSmsProvider()
		}

		if (httpOk(response)) { }
	}

	function addItem() {
		var dataCopy = { ...data }

		if (!dataCopy.users) dataCopy.users = []
		dataCopy.users.push({
			'user_id': null,
			'external_user_id': null,
		})

		setData(dataCopy)
	}

	async function deleteItem(item) {
		var dataCopy = { ...data }

		if (item.id) {
			var response = await DELETE(`/chain/telephony-provider/users/${item.id}`, {}, { loader: true })
			if (!httpOk(response)) return
		}

		var index = dataCopy.users.findIndex(user => (user.id === item.user))
		dataCopy.users.splice(index, 1)

		setData(dataCopy)
	}

	function handleSelect(option, index) {
		var dataCopy = { ...data }

		dataCopy['users'][index]['user_id'] = option.id

		setData(dataCopy)
	}

	function handleChange(e, index) {
		var dataCopy = { ...data }

		dataCopy['users'][index][e.target.name] = e.target.value

		setData(dataCopy)
	}

	async function getSmsProviderTypes() {
		const response = await GET('/helper/telephony-providers')
		if (httpOk(response)) setProviderTypes(response.data)
	}

	async function getEmployees() {
		const response = await GET('/helper/employees')
		if (httpOk(response)) setUsers(response.data)
	}

	useEffect(() => {
		getSmsProvider()
		getSmsProviderTypes()
		getEmployees()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('telephony')}
					</h4>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="row">
						<div className="col-md-4">
							<div className="form-group">
								<label>{t('type')}</label>
								<Select
									options={providerTypes}
									value={providerTypes.find(option => option.id === data.integration_provider_id) || ''}
									onChange={(option) => setData({
										...data,
										'integration_provider_id': option.id,
										'schema': option.schema,
										'config': option.config,
									})}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							{!!data.schema &&
								<div className="card-code">
									{Object.entries(data.schema).map(([key, value]) => (
										<div key={key} style={{ marginBottom: '5px' }}>
											<strong>{key}:</strong>{' '}
											{typeof value === 'object'
												? JSON.stringify(value)
												: value}
										</div>
									))}
								</div>
							}

							<div className="d-flex justify-content-between">
								<div className="vertical-center">
									<h5><b>{t('employees')}</b></h5>
								</div>
								<div className="d-flex justify-content-center">
									<div className="table-action-button table-action-primary-button"
										onClick={() => addItem()}>
										<i className="uil-plus"></i>
									</div>
								</div>
							</div>

							{!!data?.users?.length &&
								<>
									{data?.users.map((item, index) => (
										<div className="d-flex gap-2" key={index}>
											<div className="form-group w-100">
												<label>{t('employee')}</label>
												<Select
													className="w-100"
													options={users}
													value={users.find(option => option.id === item.user_id)}
													onChange={(option) => handleSelect(option, index)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group w-100">
												<label>ID</label>
												<input type="text" className="form-control"
													name="external_user_id"
													autoComplete="off"
													value={item.external_user_id}
													onChange={(e) => handleChange(e, index)} />
											</div>

											<div className="d-flex justify-content-center">
												<div className="table-action-button table-action-danger-button"
													onClick={() => deleteItem(item)}>
													<i className="uil-times"></i>
												</div>
											</div>
										</div>
									))}
								</>
							}
						</div>
					</div>

					<div className="btn-wrapper gap-2">
						<Link className="btn btn-warning btn-rounded btn-wide" to="/external-integrations">
							{t('cancel')}
						</Link>
						<button type="button" className="btn btn-primary btn-rounded btn-wide"
							onClick={(e) => createUpdate(e)}>
							{t('save')}
						</button>
					</div>
				</div>
			</div>
		</>
	)
}

export default Index